import { EndpointDetailsNirvanaDataProvider } from '../dataProvider/EndpointDetailsNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../webcomponents.constants';

export class EndpointDetailsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, EndpointDetailsNirvanaDataProvider);
  }
}
